import api from "../../../utils/api";
import { validate } from "uuid";

export const createCiType = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/citypes/", payload);
  return res.data;
};

export const readCiType = async (publicId) => {
  if (!publicId || !validate(publicId)) throw new Error("Invalid ID for CI type!");
  const res = await api.get(`/citypes/${publicId}`);
  return res.data;
};

export const readCiTypeImageBlobUrl = async (publicId) => {
  if (!publicId || !validate(publicId)) throw new Error("Invalid ID for CI type!");
  const res = await api.get(`/citypes/${publicId}/icon`, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  console.log(`Fetched image blob URL for CI type ${publicId}:`, blobUrl);
  return blobUrl;
};

export const readCiTypes = async ({ parent_id = null, depth = null }) => {
  if (process.env.NODE_ENV === "development") console.log(`readCiTypes: parent_id=${parent_id}, depth=${depth}`);
  const res = await api.get("/citypes", { params: { parent_id, depth } });
  return res.data;
};

export const updateCiType = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id || !validate(payload.public_id)) throw new Error("Invalid ID for CI type");
  const res = await api.put(`/citypes/${payload.public_id}`, payload);
  return res.data;
};

export const updateCiTypeIcon = async ({ item, file }) => {
  console.log(`id ${item.public_id} - file ${file}`);
  const formData = new FormData();
  formData.append("entity_type", "ci_types");
  formData.append("entity_id", item.id);
  formData.append("file", file); // 'id' is already in the URL
  // const res = await api.post(`/citypes/${item.public_id}/icon`, formData); // No headers here
  // return updateCiType({ ...item, icon_url: `citypes/icons/${item.public_id}` }); // return item with icon URL if icon upload
  const res = await api.post(`/files`, formData); // No headers here
  return res.status === 201 ? updateCiType({ ...item, icon_id: res.data?.id }) : res; // If the icon has been uploaded successfully, update icon_id and return item
};

export const deleteCiType = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId || !validate(publicId)) throw new Error("Invalid ID for CI type!");
  return await api.delete(`/citypes/${publicId}`);
};
